import AnnualPeriodsError from './AnnualPeriodsError';
class AnnualPeriodsBricksRequired extends AnnualPeriodsError {
    constructor(options) {
        super('The number of bricks is not sent without promotional coupon', options);
    }
}
export default AnnualPeriodsBricksRequired;
